document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const formSubmitted = urlParams.has('customer_posted');

    if (formSubmitted) {
        return; 
    }

    const targetElement = document.querySelector('.fomo-signup-contents-container .fomo-signup-header.pre');

    if (targetElement) {
        const h4 = document.createElement('h4');
        h4.textContent = 'Visions Unveiled:';
        h4.style.margin = '0'; 
        h4.style.padding = '0';
        
        const h5 = document.createElement('h5');
        h5.innerHTML = 'A Troy Brooks Limited Edition Print Collection';
        h5.style.margin = '0'; 
        h5.style.padding = '0';
        
        targetElement.innerHTML = '';
        targetElement.appendChild(h4);
        targetElement.appendChild(h5);
    }
});